// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-search-outer {

    height: 2vw;
    /* min-width: 21vw; */
    /* display: grid;
    
    grid-template-columns: .1fr auto .1fr; */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: .25vw;
    padding: .15vw .15vw .15vw .5vw;
}

.main-search-outer span {
    display: flex; /* Add this line */
    align-items: center; /* And this */
    justify-content: center; /* Optional, for symmetry */
    height: 1vw;
    width: 1vw;
    margin-right: .15vw;
}


.main-search-outer input {
    flex-grow: 1;
    height: 100%;
    font-family: "Poppins";
    font-weight: 500;
    border: none;
    font-size: .7vw;
    background: transparent;
    &::placeholder {
        color: #8B8B8B;
        font-size: .7vw;
        font-family: "Poppins";
        font-weight: 500;
    }
}

.main-search-btn {
    /* background-color: black; */
    cursor: pointer;
    border: none;
    height: 100%;
    /* color: white; */
    font-family: "Poppins";
    font-weight: 500;
    font-size: .6vw;
    padding: .25vw .5vw;
    border-radius: .25vw;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/search/newSearchStyle.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,qBAAqB;IACrB;;4CAEwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,aAAa,EAAE,kBAAkB;IACjC,mBAAmB,EAAE,aAAa;IAClC,uBAAuB,EAAE,2BAA2B;IACpD,WAAW;IACX,UAAU;IACV,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB;QACI,cAAc;QACd,eAAe;QACf,sBAAsB;QACtB,gBAAgB;IACpB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":[".main-search-outer {\n\n    height: 2vw;\n    /* min-width: 21vw; */\n    /* display: grid;\n    \n    grid-template-columns: .1fr auto .1fr; */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: .25vw;\n    padding: .15vw .15vw .15vw .5vw;\n}\n\n.main-search-outer span {\n    display: flex; /* Add this line */\n    align-items: center; /* And this */\n    justify-content: center; /* Optional, for symmetry */\n    height: 1vw;\n    width: 1vw;\n    margin-right: .15vw;\n}\n\n\n.main-search-outer input {\n    flex-grow: 1;\n    height: 100%;\n    font-family: \"Poppins\";\n    font-weight: 500;\n    border: none;\n    font-size: .7vw;\n    background: transparent;\n    &::placeholder {\n        color: #8B8B8B;\n        font-size: .7vw;\n        font-family: \"Poppins\";\n        font-weight: 500;\n    }\n}\n\n.main-search-btn {\n    /* background-color: black; */\n    cursor: pointer;\n    border: none;\n    height: 100%;\n    /* color: white; */\n    font-family: \"Poppins\";\n    font-weight: 500;\n    font-size: .6vw;\n    padding: .25vw .5vw;\n    border-radius: .25vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
